export default "__VITE_ASSET__Dy56$y5K__"